class AboutIUs extends HTMLElement {
    connectedCallback() {
        // 动画函数
        function animateStatCount(statElement) {
            var targetValue = parseInt(statElement.getAttribute('data-target'));
            var startValue = 0;
            var duration = 2000;
            var startTime = null;

            function easeInOutQuad(t, b, c, d) {
                t /= d / 2;
                if (t < 1) return (c / 2) * t * t + b;
                t--;
                return (-c / 2) * (t * (t - 2) - 1) + b;
            }

            function render(time) {
                if (!startTime) startTime = time;
                var progress = time - startTime;

                var currentValue = easeInOutQuad(progress, startValue, targetValue - startValue, duration);

                statElement.textContent = Math.floor(currentValue).toLocaleString();

                if (progress < duration) {
                    requestAnimationFrame(render);
                } else {
                    statElement.textContent = targetValue.toLocaleString();
                }
            }
            requestAnimationFrame(render);
        }

        // 监听元素是否进入视口
        function onIntersect(entries, observer) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // 只有在元素进入视口时执行动画
                    var stats = entry.target.querySelectorAll('.stat__count');
                    var numDom = entry.target.querySelectorAll('.stat__fill-count');
                    stats.forEach(function (stat) {
                        animateStatCount(stat);
                    });

                    numDom.forEach((item)=>{
                        item.textContent = parseInt(item.textContent).toLocaleString()
                    })
                    observer.unobserve(entry.target); // 执行动画后停止观察
                }
            });
        }

        // 创建 IntersectionObserver 实例
        const observer = new IntersectionObserver(onIntersect, {
            root: null, // 观察整个视口
            threshold: 0.5 // 当元素进入视口50%时触发
        });

        // 选择需要观察的元素
        const aboutIUs = this;
        observer.observe(aboutIUs); // 观察当前元素
    }
}


// 注册自定义元素
reg("about-us", AboutIUs);